import { memo } from 'react';
import { PropertyInputHighlySensitiveFloating } from './highlySensitive/PropertyInputHighlySensitiveFloating';
import { PropertyInputHighlySensitiveNonFloating } from './highlySensitive/PropertyInputHighlySensitiveNonFloating/PropertyInputHighlySensitiveNonFloating';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputHighlySensitive = props => {
  if (props.use === 'floating') {
    return /*#__PURE__*/_jsx(PropertyInputHighlySensitiveFloating, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(PropertyInputHighlySensitiveNonFloating, Object.assign({}, props));
};
export default /*#__PURE__*/memo(PropertyInputHighlySensitive);